import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../components/Projects/ProjectCard";
import Particle from "../components/Particle";
import bpAdminPanelImg from "../assets/projects/bpAdminPanel.png";
import fendiAppImg from "../assets/projects/fendiAppImg.png";
import stitchEaseImg from "../assets/projects/stitchEaseImg.png";
import bpSPA from "../assets/projects/bpSpaProject.png";
import sAndSVaultImg from "../assets/projects/s&SVaultImg.png";

const Projects = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent Top <strong className="yellow">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bpSPA}
              isBlog={false}
              title="Balloch Park (SPA)"
              description="Balloch Park (SPA) is a stunning Single Page Application (SPA) built with React,
              leveraging React Bootstrap, Redux, Typescript and Sass for responsive front-end design. 
              Custom APIs built with Node.js and Express.js fetch real-time data to populate the site's content.
             Utilizing MongoDB to store and manage data efficiently. The integration of React with React Bootstrap and Sass not only ensures aesthetic appeal but also enhances performance and maintainability."
              demoLink="https://balloch-park-single-page.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bpAdminPanelImg}
              isBlog={false}
              title="Balloch Park Admin Panel"
              description="Balloch Park Admin Panel built using React, React Bootstrap, Typescript and Sass. Using this admin panel 
              admins of Balloch Park can manage, add and delete the content and other staff of Balloch Park SPA. 
              With the integration of Google Maps API, users can easily access 
              directions on the map and set/edit the locations on map. The platform allows for full CURD 
              functionality on locations, grapghs, content and screen types. Additionally, users can easily reset their password. 
              The backend is powered by Nodejs and Expressjs server, while MongoDB is utilized as the database management."
              demoLink="https://balloch-park-admin-panel.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sAndSVaultImg}
              isBlog={false}
              title="S & S Vault"
              description="S & S Vault is a robust platform designed to empower users with secure storage management capabilities, offering up to 5 MB of free storage.
              Users can create folders and manage files with ease, utilizing RESTful APIs for posting and fetching files and folders. 
              For those requiring more storage, the platform integrates with Stripe for easy plan purchases.
              Users with admin role permission can maintains other users through data tables, facilitating smooth onboarding and access control.
              The platform is built using React, styled-components, React Bootstrap and Sass with responsive user experience.
              "
              demoLink="https://p-and-s-services-33412-staging.botics.co/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fendiAppImg}
              isBlog={false}
              title="Fendi React Web App"
              description="Fendi is a responsive mobile application designed for sales management. Built with React, Redux,  React Bootstrap, and Sass, and enhanced with TypeScript.
              Application supports three distinct roles: staff, managers, and general managers. Each role has specific privileges tailored to their responsibilities.
              Managers and general managers have access to comprehensive insights into staff activities and sales performance. They can monitor the sales of individual staff members and track their activity within the application.
              The application integrates a RESTful API for efficient data management, ensuring seamless communication between the frontend and backend systems.
              TypeScript is utilized to enhance code quality and maintainability.
              "
              demoLink="https://trackizer.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={stitchEaseImg}
              isBlog={false}
              title="Stitch Ease"
              description="Stitch Ease is developed using React with Typescript and styled with React Bootstrap and Sass, ensuring a modern and user-friendly responsive interface.
              Stitch Ease caters to two primary roles: tailors and customers. Customers can browse verified tailors and place orders directly with their preferred tailor.
              Once an order is placed, tailors receive notifications to accept or reject the order. Upon acceptance, customers can make payments securely through Stripe. Payment is only released to the tailor upon delivery and confirmation from the customer.
              Customers have access to their order history, allowing them to review past orders and easily reorder garments. 
              Firebase is utilized directly to manage the React application, offering authentication, integration and efficient data handling.
              "
              demoLink="https://stitch-ease.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Projects;
